import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import AvailableOn from "../../AvailableOn/AvailableOn";
import useReveal from "../../../hooks/useReveal";
import "./Makingprocess.css";

function Makingprocess() {
  useReveal();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>KUKUNAMKEEN | Authentic Indian Namkeens | Free Shipping</title>
        <meta
          name="description"
          content="Explore the meticulous process behind the creation of our authentic Indian namkeens in four precise steps. From crafting the flavorful center filling of kachori using gram flour, spices, and refined sugar to encasing it within a delicate outer layer made from pure refined wheat flour, every detail is attended to with care. The final touch involves frying the kachoris in Pure Cottonseed oil for a perfect crispiness. Experience the essence of traditional Indian snacks with KUKUNAMKEEN. Enjoy Free Shipping on all orders."
        />
        <meta
          name="keywords"
          content="KUKUNAMKEEN, Indian Namkeens, Kachori, Authentic Snacks, Free Shipping, Gram Flour, Refined Wheat Flour, Pure Cottonseed Oil"
        />
        <link rel="canonical" href={`https://kukunamkeen.in/makingprocess`} />
      </Helmet>

      {/* section-header title */}
      <section className="section-header-title navigation-space-mob">
        <div className="container mx-auto">
          <h1>MAKING PROCESS</h1>
        </div>
      </section>
      <img
        src="/Image/border-bottom-title.png"
        className="w-full header-title-image"
        alt=""
      />
      {/* section-header title */}

      {/* distributor-page showing making steps */}
      <section className="distributor-page section-space overflow-hidden">
        <div className="container mx-auto px-4 lg:px-24">
          <div className="flex flex-wrap justify-center -mx-4">
            <div className="w-full md:w-1/2 p-4 reveal">
              <img src="/Image/making-steps-1.png" alt="Step 1" />
            </div>
            <div className="w-full md:w-1/2 p-4 reveal">
              <img src="/Image/making-steps-2.png" alt="Step 2" />
            </div>
            <div className="w-full md:w-1/2 p-4 reveal">
              <img src="/Image/making-steps-3.png" alt="Step 3" />
            </div>
            <div className="w-full md:w-1/2 p-4 reveal">
              <img src="/Image/making-steps-4.png" alt="Step 4" />
            </div>
          </div>
        </div>
      </section>

      {/* also available on section */}
      <AvailableOn />
    </>
  );
}

export default Makingprocess;
